// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"260":"3e7f9b01","307":"bb1a15ea"}[chunkId] + ".css";
};